<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/m9EOBo/tc-custom/9781453233412.jpg?1705003725426" alt="This image is the cover for the book Moment of Violence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moment of Violence
      </h1>
      <p class="bookDescription body article font2">
        <b>A lawyer travels to Barbados to protect an old friend from a swindle</b>David Payne is only twelve hours from vacation when he gets the fateful summons. Professor John Alison, David’s mentor and most prominent client, needs him to go to Barbados—and if he doesn’t tread carefully, he may not return. David is charged with checking on a beachfront property owned by the professor—which an unscrupulous rat named Mike Ludlow is trying to swindle away. The professor is too tired to fight, but his daughter has other ideas. She has snuck away to Barbados, and she’s brought the professor’s gun. David Payne’s job is to stop the bloodshed before it starts—but he might not get there in time.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Harmon Coxe
      </h2>
      
      <p class="authorDescription body article">George Harmon Coxe (1901&ndash;1984) was an early star of hard-boiled crime fiction, best known for characters he created in the seminal pulp magazine <i>Black Mask</i>. Born in upstate New York, he attended Purdue and Cornell Universities before moving to the West Coast to work in newspapers. In 1922 he began publishing short stories in pulp magazines across various genres, including romance and sports. He would find his greatest success, however, writing crime fiction.&#160;In 1934 Coxe, relying on his background in journalism, created his most enduring character: Jack &ldquo;Flashgun&rdquo; Casey, a crime photographer. First appearing in &ldquo;Return Engagement,&rdquo; a <i>Black Mask </i>short, Casey found success on every platform, including radio, television, and film. Coxe&rsquo;s other well-known characters include Kent Murdock, another photographer, and Jack Fenner, a PI. Always more interested in character development than a clever plot twist, Coxe was at home in novel-writing, producing sixty-three books in his lifetime. Made a Grand Master of the Mystery Writers of America in 1964, Coxe died in 1984.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22eabcf4